<template>
    <template-layout fullheader="true">
        <template slot="header">
            <div class="container">
                <div class="columns">
                    <div class="column is-one-fifth"></div>
                    <div class="column">
                        <div v-if="emailSent === false" class="box">
                            <h1 class="title">Valida tu correo electrónico</h1>

                            <p style="margin-bottom: 20px;">Como parte de nuestra nueva web en el corto plazo estaremos quitando la opción de iniciar
                            sesión con un nombre de usuario y pasará a ser simplemente con tu dirección de correo electrónico.</p>

                            <p style="margin-bottom: 20px;">Por este motivo te pedimos que antes de continuar ingreses tu dirección y confirmes
                            la misma con el correo que te enviaremos.</p>

                            <b-field label="Ingresá tu correo electrónico">
                                <b-input v-model="email" name="email" type="text" placeholder=""></b-input>
                            </b-field>

                            <button class="button is-primary" :class="{ 'is-loading': isLoading }" v-on:click.prevent="onVerifyClicked">Verificar</button>
                        </div>

                        <div v-else class="box">
                            <h1 class="title">Revisá tu correo</h1>

                            <p>Te enviamos un correo para verificar tu dirección.</p>
                        </div>

                    </div>
                    <div class="column is-one-fifth"></div>
                </div>
            </div>
        </template>

        <template slot="content">

        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from '../layout/TemplateLayout.vue';

    export default {
        name: 'validateEmail',

        data() {
            return {
                isLoading: false,
                email: '',
                emailSent: false
            }
        },

        components: {
            TemplateLayout,
        },

        mounted() {
            this.email = this.$store.state.customer.email;
        },

        methods: {
            onVerifyClicked() {
                this.isLoading = true;

                return this.$store.dispatch('customer/patch', { email: this.email }).then((/*response*/) => {
                    this.emailSent = true;
                }).catch((/*error*/) => {

                }).finally(() => {
                    this.isLoading = false;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>